import React, { ReactElement, useEffect, useState } from "react";
import {
    FieldTypedValue, FormField, FormFieldReplacementInput, FormFieldType,
} from "../../../__generated__/api";
import FieldTypeValueDisplay from "../../form-field/FieldTypeValueDisplay";
import FieldSelector, { SelectedGroup } from "../../pickers/field-selector/FieldSelector";
import { ReplacementGroup } from "../../replacement-group";
import { ActionProps } from "./base";

const FORM_GROUP_ID = "urn:fq:form-field-group:request";

const FORM_FIELD_ID = "urn:fq:workflow-service-form-field:(urn:fq:workflow-service:system,field)";
const FORM_VALUE_ID = "urn:fq:workflow-service-form-field:(urn:fq:workflow-service:system,value)";

export default function SetTicketFieldValueSettings(props: ActionProps): ReactElement {
    const requestGroup = props.input.find(group => group.id === FORM_GROUP_ID) as ReplacementGroup;

    const fieldIdInput = props.values.find(row => row.value.fieldId === FORM_FIELD_ID)?.value.string;
    const fieldValueInput = props.values.find(row => row.value.fieldId === FORM_VALUE_ID)?.value;

    const [selectedField, setSelectedField] = useState<SelectedGroup>();
    const [fieldValue, setFieldValue] = useState<FieldTypedValue>();
    const [replacements, setReplacements] = useState<FormFieldReplacementInput[]>();

    useEffect(() => {
        if (selectedField && fieldValue != null) {
            props.onChange({
                values: [
                    {
                        fieldId: FORM_FIELD_ID,
                        type: FormFieldType.Text,
                        displayValue: selectedField.field.name,
                        string: selectedField.field.id,
                    },
                    {
                        ...fieldValue,
                        fieldId: FORM_VALUE_ID,
                    },
                ],
                replacements,
            });
        }
    }, [selectedField?.field.id, fieldValue]);

    useEffect(() => {
        const field = fieldIdInput ? requestGroup?.input?.find(row => row?.id === fieldIdInput) : undefined;
        if (field && requestGroup && field?.id !== selectedField?.field.id) {
            setSelectedField({
                field,
                group: requestGroup,
            });
        }
    }, [requestGroup.input, fieldIdInput]);

    useEffect(() => {
        if (fieldValueInput) {
            setFieldValue(fieldValueInput);
        }
    }, [
        fieldValueInput?.boolean
        ?? fieldValueInput?.date
        ?? fieldValueInput?.displayValue
        ?? fieldValueInput?.fieldId
        ?? fieldValueInput?.number
         ?? fieldValueInput?.options
         ?? fieldValueInput?.string
         ?? fieldValueInput?.type,
    ]);

    useEffect(() => {
        if (selectedField?.field.type && selectedField?.field.type !== fieldValueInput?.type) {
            setFieldValue(undefined);
        }
    }, [selectedField?.field.type, fieldValueInput?.type]);

    return (
        <div className="">
            <div>
                <div className="">
                    Field
                </div>

                <div className="">
                    <FieldSelector
                        onChange={value => {
                            setSelectedField(value);
                        }}
                        value={selectedField}
                        input={[requestGroup]}
                    />
                </div>
                <small>
                    Select which field you want to modify
                </small>
            </div>
            {selectedField && (
                <div>
                    <div className="mt-3">
                        Value
                    </div>

                    <div className="">
                        <FieldTypeValueDisplay
                            className=""
                            field={selectedField?.field as FormField}
                            shouldShowFieldName={false}
                            value={fieldValue}
                            onChange={(value, replace) => {
                                setFieldValue(value);
                                setReplacements(replace);
                            }}
                            replaceableInput={props.input}
                        />
                    </div>
                    <small>
                        What do you want to set the value to?
                    </small>
                </div>
            )}

        </div>

    );
}
